import { useQuery } from "@tanstack/react-query";
import {
  EuTaxonomyActivityDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_EU_TAXONOMY_ACTIVITY } from "../domain";

import { euTaxonomyActivityApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_ACTIVITIES = "GET_ACTIVITIES";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getActivities = async (
  categoryId: string,
): Promise<EuTaxonomyActivityDto[]> => {
  const response =
    await euTaxonomyActivityApi.euTaxonomyActivityControllerGetEuTaxonomyActivities(
      categoryId,
    );

  return response.data;
};

export const useGetActivities = (
  categoryId: string,
  user: UserProfileDto | null,
): {
  activities: EuTaxonomyActivityDto[] | undefined;
  activitiesEnabled: boolean;
  isPendingGetActivities: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { isPending, data } = useQuery({
    queryKey: [DOMAIN_EU_TAXONOMY_ACTIVITY, ACTION_GET_ACTIVITIES, categoryId],
    queryFn: () => getActivities(categoryId),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    activities: data,
    activitiesEnabled: enabled,
    isPendingGetActivities: isPending,
  };
};
